<template>
  <div>
    <b-modal
        scrollable
      id="ship-order"
      ref="modal"
      header-class="headerModal"
      centered
      :title="$t('ShipToStore')"
      hide-footer
      size="lg"
      @hide="onCancel"
    >
      <b-form>
        <div style="display:flex;gap: 15px;padding-bottom: 5px;">
          <b-form-group
            style="width: 100%;"
            :label="$t('SelectD')"
          >
            <date-picker
              v-model="movementDate"
              value-type="format"
              :placeholder="$t('SelectD')"
              :format="'YYYY-MM-DD'"
              :clearable="false"
              :lang="lang"
              style="width: 100%;"
            />
          </b-form-group>
          <b-form-group
            style="width: 100%;"
            :label="$t('From')"
          >
            <vue-select
              v-model="fromLocation"
              :options="getLocationsMoving"
              label="locationName"
              :reduce="(e) => e.locationId"
              :placeholder="$t('From')"
            />
          </b-form-group>
        </div>
        <div style="display: flex; gap:15px;padding-bottom: 5px;">
          <b-form-group
            style="width: 100%;"
            :label="$t('To')"
          >
            <vue-select
              v-model="toLocation"
              :options="getLocationsMoving"
              label="locationName"
              :reduce="(e) => e.locationId"
              :placeholder="$t('To')"
              style="width: 100%;"
            />
          </b-form-group>
          <b-form-group
            style="width: 100%;"
            :label="$t('AssignTeam')"
          >
            <vue-select
              v-model="teams"
              :options="getTeamsNames"
              label="teamName"
              :reduce="(e) => e.teamNameId"
              :placeholder="$t('AssignTeam')"
              style="width: 100%;"
            />
          </b-form-group>
        </div>
        <div style="display: flex; gap:15px;padding-bottom: 5px;">
          <b-form-group
            :label="$t('Orders')"
            style="width: 100%;"
          >
            <vue-select
              v-model="orderItemIdss"
              :options="orderItemIds"
              :reduce="(e) => e.orderItemId"
              label="orderNumber"
              style="width: 100%;"
              :multiple="true"
              :placeholder="$t('Select')"
            />
          </b-form-group>
          <b-form-group
            :label="$t('Orders')"
            style="width: 100%;"
          >
            <vue-select
              v-model="orderStates"
              class="custom-select2"
              style="width: 100%;"
              label="text"
              :reduce="(e) => e.value"
              :placeholder="$t('Select')"
              :options="stateOptionsFiltered"
            />
          </b-form-group>
        </div>

      </b-form>
      <div class="buttonsEverywhere">
        <b-button
          type="button"
          variant="none"
          style="margin-left: 0px; background: #FF274F !important;"
          class="buttonSubmit"
          :disabled="isButtonDisabled"
          @click="onSubmit"
        >
          {{ $t('Confirm') }}
        </b-button>
        <b-button
          type="reset"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"
          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    DatePicker,
  },
  props: ['orderItemIds'],
  data() {
    return {
      orderStates: null,
      teams: null,
      fromLocation: null,
      toLocation: null,
      movementDate: null,
      orderItemIdss: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['getLocationsMoving', 'getTeamsNames', 'getOrderItemStates']),
    isButtonDisabled() {
      return (
        !this.teams
        || !this.fromLocation
        || !this.toLocation
        || !this.movementDate
        || !this.orderStates
        || this.orderItemIdss.length === 0
      );
    },
    stateOptionsFiltered() {
      const optionsState = [
        'Created',
        'Assigned',
        'Confirmed',
        'ReadyToDeliver',
        'Delivered',
      ]
      const options = optionsState.map((state) => {
        return {
          value: state,
          text: this.$t(state),
        }
      });

      const filteredOptions = [...options];

      return filteredOptions;
    },
  },
  watch: {
    orderItemIds(value) {
      if (value) {
        this.orderItemIdss = value
      }
    },
  },
  methods: {
    onSubmit() {
      const orders = this.orderItemIdss.map((item) => { return item.orderItemId ? item.orderItemId : item })
      const objekti = {
        form: {
          deliverDate: this.movementDate,
          deliverLocationId: this.fromLocation,
          receiverLocationId: this.toLocation,
          teamNameId: this.teams,
          orderItemIds: orders,
        },
        newOrderItemState: this.orderStates,
      }
      console.log('onSubmit', objekti)
      this.$emit('onSubmit', objekti)
      this.$refs.modal.hide()
      this.resetForm()
    },
    onCancel() {
      this.$refs.modal.hide()
      this.resetForm()
    },
    resetForm() {
      this.fromLocation = null
      this.teams = null
      this.toLocation = null
      this.movementDate = null
      this.orderStates = null
      if (this.orderItemIdss != this.orderItemIds) {
        this.orderItemIdss = this.orderItemIds
      }
    },
  },
}
</script>

<style>
.mx-input {
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 38px;
    padding: 0px 34px;
    padding-left: 10px;
    font-size: 14px;
    line-height: 1.4;
    color: #555;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
}
</style>
